// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prof-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
  padding: 20px;
  background: var(--grad-brand);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-brand);
}

.prof-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.prof-avatar {
  display: block;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.35);
}

.prof-avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-family: var(--font-display);
  font-size: 1.4rem;
  font-weight: 800;
}

.prof-file {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.prof-avatar-btn {
  position: absolute;
  right: -2px;
  bottom: -2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--danger);
  color: #fff;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: background 0.2s;
}

.prof-avatar-btn:hover {
  background: var(--danger-700);
}

.prof-hero-info {
  min-width: 0;
}

.prof-hero-info strong {
  display: block;
  font-family: var(--font-display);
  font-size: 1.16rem;
  font-weight: 800;
  color: #fff;
}

.prof-hero-info > span {
  display: block;
  font-size: 0.86rem;
  color: rgba(255, 255, 255, 0.82);
  overflow: hidden;
  text-overflow: ellipsis;
}

.prof-role {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  margin-top: 9px;
  background: rgba(255, 255, 255, 0.18) !important;
  border-color: transparent !important;
  color: #fff !important;
}

.prof-danger:hover {
  border-color: var(--danger-100);
  background: var(--danger-50);
  color: var(--danger);
}

.prof-danger-solid {
  background: var(--danger);
}

.prof-danger-solid:hover:not(:disabled) {
  background: var(--danger-700);
}

.prof-refresh {
  border: 0;
  background: none;
  padding: 4px;
  font-size: 0.82rem;
  color: var(--muted2);
  text-decoration: underline;
  cursor: pointer;
}

.prof-refresh:hover {
  color: var(--brand);
}

@media (max-width: 520px) {
  .prof-hero {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/account/Profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".prof-hero {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 18px;\n  padding: 20px;\n  background: var(--grad-brand);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-brand);\n}\n\n.prof-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.prof-avatar {\n  display: block;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid rgba(255, 255, 255, 0.35);\n}\n\n.prof-avatar-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-family: var(--font-display);\n  font-size: 1.4rem;\n  font-weight: 800;\n}\n\n.prof-file {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.prof-avatar-btn {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--danger);\n  color: #fff;\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n  transition: background 0.2s;\n}\n\n.prof-avatar-btn:hover {\n  background: var(--danger-700);\n}\n\n.prof-hero-info {\n  min-width: 0;\n}\n\n.prof-hero-info strong {\n  display: block;\n  font-family: var(--font-display);\n  font-size: 1.16rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n.prof-hero-info > span {\n  display: block;\n  font-size: 0.86rem;\n  color: rgba(255, 255, 255, 0.82);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.prof-role {\n  display: inline-flex !important;\n  align-items: center;\n  gap: 5px;\n  margin-top: 9px;\n  background: rgba(255, 255, 255, 0.18) !important;\n  border-color: transparent !important;\n  color: #fff !important;\n}\n\n.prof-danger:hover {\n  border-color: var(--danger-100);\n  background: var(--danger-50);\n  color: var(--danger);\n}\n\n.prof-danger-solid {\n  background: var(--danger);\n}\n\n.prof-danger-solid:hover:not(:disabled) {\n  background: var(--danger-700);\n}\n\n.prof-refresh {\n  border: 0;\n  background: none;\n  padding: 4px;\n  font-size: 0.82rem;\n  color: var(--muted2);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.prof-refresh:hover {\n  color: var(--brand);\n}\n\n@media (max-width: 520px) {\n  .prof-hero {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
